export const cssConfig = {
  shouldForwardProp: (prop, defaultValidatorFn) =>
    (!["width", "height", "color", "backgroundColor"].includes(prop) &&
      defaultValidatorFn(prop)) ||
    prop === "data-cta-location" ||
    prop === "data-remove",
}
